import { Component, Inject, OnInit, ViewEncapsulation } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { FormGroup, Validators, FormBuilder } from "@angular/forms";
import { RecordAction } from "../../../../../../utils/enums/shared/enums";
import { AuthenticationService } from "../../../../../../services/security/authentication.service";
import { SmsDTO } from "../../../../../../utils/types/sms/smsDTO.type";
import { Grupo } from "../../../../../../utils/types/groups/grupo.type";
import { GruposService } from "../../../../../../services/groups/grupos.service";
import { SharedCatalogService } from "../../../../../../services/shared/sharedcatalog.service";
import * as moment from "moment";

import * as toastr from "toastr";
import { TranslateService } from "@ngx-translate/core";
import { ContactRule } from "../../../../../../utils/types/admon/contact-rule.type";
import { SMSTemplate } from "../../../../../../utils/types/sms/sms-template.type";
import { SmsTemplateService } from "../../../../../../services/sms/sms-template.service";
import { MatSelectChange } from "@angular/material/select";

@Component({
    selector: "wtf-sms-programado-form",
    templateUrl: "./sms-programado-form.component.html",
    styleUrls: ["./sms-programado-form.component.scss"],
    providers: [
        GruposService,
        AuthenticationService,
        SharedCatalogService,
        SmsTemplateService,
    ],
    encapsulation: ViewEncapsulation.None,
})
export class SmsProgramadoFormComponent implements OnInit {
    smsModel: SmsDTO;
    dialogTitle: string;
    hideMessage: boolean = false;
    isWaiting = false;
    firstFormGroup: FormGroup;
    secondFormGroup: FormGroup;

    smsProgramacionForm: FormGroup;

    action: RecordAction;
    callback: (sms) => void;

    disabledDiasEspecificos = true;
    operators: any;
    // presetColors = MatColors.presets;
    recordAction = RecordAction;
    grupos: Grupo[];
    shortCodes: any;
    recurrenceDays: String[];
    hasURL: boolean;
    contactRule: ContactRule;
    smsTemplates: SMSTemplate[] = [];
    smsFilteredTemplates: SMSTemplate[] = [];

    checkedRadioButon: number;
    resetSelection = false;
    esRecurrente = false;

    constructor(
        public dialogRef: MatDialogRef<SmsProgramadoFormComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any,
        private sharedCatalog: SharedCatalogService,
        private _formBuilder: FormBuilder,
        private translateService: TranslateService,
        private smsTemplateService: SmsTemplateService
    ) {
        this.translateService.setDefaultLang("en");
        this.translateService.use(localStorage.getItem("language") || "en");
        this.smsModel = data.sms;
        this.action = data.action;
        this.shortCodes = data.shortCodes;
        this.callback = data.callback;
        this.grupos = data.grupos;
        this.contactRule = data.contactRule;

        if (
            this.action === RecordAction.Update ||
            this.action === RecordAction.View
        ) {
            this.dialogTitle = "Campaña SMS";
            this.dialogTitle = this.translateService.instant(this.dialogTitle);
        } else {
            this.dialogTitle = "Programar Envio de Campaña SMS";
            this.dialogTitle = this.translateService.instant(this.dialogTitle);
            this.smsModel = new SmsDTO();
            this.resetSelection = true;
        }

        if (this.smsModel.longUrl) {
            this.hasURL = true;
        }

        switch (this.smsModel.recurrence_mode) {
            case "1111111":
                this.checkedRadioButon = 1;
                this.resetSelection = true;
                break;

            default:
                this.checkedRadioButon = 3;
                this.disabledDiasEspecificos = false;
                break;
        }

        this.recurrenceDays = this.smsModel.recurrence_mode.split("");

        if (
            moment(this.smsModel.execute_date, "YYYY-MM-DD").toDate() <
            moment(this.smsModel.execute_end_date, "YYYY-MM-DD").toDate()
        ) {
            this.esRecurrente = true;
        }

        this.buildFirstForm();
        this.buildSecondForm();
    }

    loadTemplates() {
        this.smsTemplateService
            .getTemplates({ onlyactives: true })
            .subscribe((res) => {
                this.smsTemplates = res.rows;
                this.smsFilteredTemplates = this.smsTemplates;
            });
    }

    onKey(event) {
        this.smsFilteredTemplates = this.search(event.value);
    }

    search(value: string) {
        let filter = value.toLowerCase();
        return this.smsTemplates.filter((option) =>
            option.name.toLowerCase().startsWith(filter)
        );
    }

    onChangeHideMessage(event) {
        this.hideMessage = event.checked;
    }

    private buildFirstForm() {
        this.firstFormGroup = this._formBuilder.group({
            name: [this.smsModel.name, Validators.required],
            shortcode: [{ value: this.smsModel.shortCode, disabled: true }],
            service_type: [
                { value: this.smsModel.service_type, disabled: true },
            ],
            template: [{ id: this.smsModel.template_id }],
            grupo: [
                { value: this.smsModel.groups, disabled: true },
                Validators.required,
            ],
            message: [{ value: this.smsModel.message, disabled: true }],
            longUrl: [{ value: this.smsModel.longUrl, disabled: true }],
            validityPeriod: [this.smsModel.validityPeriod, Validators.required],
        });

        this.firstFormGroup.controls["name"].valueChanges.subscribe(
            (value) => (this.smsModel.name = value)
        );
        this.firstFormGroup.controls["message"].valueChanges.subscribe(
            (value) => (this.smsModel.message = value)
        );
        this.firstFormGroup.controls["longUrl"].valueChanges.subscribe(
            (value) => (this.smsModel.longUrl = value)
        );
        this.firstFormGroup.controls["validityPeriod"].valueChanges.subscribe(
            (value) => (this.smsModel.validityPeriod = value)
        );

        this.firstFormGroup.controls["grupo"].valueChanges.subscribe(
            (value) => {
                this.smsModel.groups = value;
            }
        );

        this.hideMessage = this.smsModel.obfuscated;
    }

    private buildSecondForm() {
        this.secondFormGroup = this._formBuilder.group(
            {
                esRecurrente: [this.esRecurrente],
                esActivo: [Boolean(this.smsModel.status.id)],
                fechaInicio: [
                    moment(this.smsModel.execute_date, "YYYY-MM-DD").toDate(),
                    Validators.required,
                ],
                fechaFin: [
                    moment(
                        this.smsModel.execute_end_date,
                        "YYYY-MM-DD"
                    ).toDate(),
                ],
                time: [this.smsModel.execute_time],

                lunes: [Boolean(Number(this.recurrenceDays[1]))],
                martes: [Boolean(Number(this.recurrenceDays[2]))],
                miercoles: [Boolean(Number(this.recurrenceDays[3]))],
                jueves: [Boolean(Number(this.recurrenceDays[4]))],
                viernes: [Boolean(Number(this.recurrenceDays[5]))],
                sabado: [Boolean(Number(this.recurrenceDays[6]))],
                domingo: [Boolean(Number(this.recurrenceDays[0]))],
            },
            { validator: this.dateLessThan("fechaInicio", "fechaFin") }
        );

        this.secondFormGroup.controls["esRecurrente"].valueChanges.subscribe(
            (value) => {
                this.esRecurrente = value;
                // tslint:disable-next-line:prefer-const

                if (this.esRecurrente === false) {
                    const changeEvent: any = { value: 1 };
                    this.radioChange(changeEvent);
                    this.secondFormGroup.get("fechaFin").clearValidators();
                    this.secondFormGroup.get("fechaFin").setValue(null);
                    this.secondFormGroup
                        .get("fechaFin")
                        .updateValueAndValidity();
                }
            }
        );

        this.secondFormGroup.controls["esActivo"].valueChanges.subscribe(
            (value) => (this.smsModel.statusId = Number(value))
        );

        this.secondFormGroup.controls["fechaInicio"].valueChanges.subscribe(
            (value) => (this.smsModel.execute_date = value)
        );
        this.secondFormGroup.controls["fechaFin"].valueChanges.subscribe(
            (value) => (this.smsModel.execute_end_date = value)
        );
        this.secondFormGroup.controls["time"].valueChanges.subscribe(
            (value) => (this.smsModel.execute_time = value)
        );

        this.secondFormGroup.controls["lunes"].valueChanges.subscribe(
            (value) => (this.recurrenceDays[1] = Number(value).toString())
        );
        this.secondFormGroup.controls["martes"].valueChanges.subscribe(
            (value) => (this.recurrenceDays[2] = Number(value).toString())
        );
        this.secondFormGroup.controls["miercoles"].valueChanges.subscribe(
            (value) => (this.recurrenceDays[3] = Number(value).toString())
        );
        this.secondFormGroup.controls["jueves"].valueChanges.subscribe(
            (value) => (this.recurrenceDays[4] = Number(value).toString())
        );
        this.secondFormGroup.controls["viernes"].valueChanges.subscribe(
            (value) => (this.recurrenceDays[5] = Number(value).toString())
        );
        this.secondFormGroup.controls["sabado"].valueChanges.subscribe(
            (value) => (this.recurrenceDays[6] = Number(value).toString())
        );
        this.secondFormGroup.controls["domingo"].valueChanges.subscribe(
            (value) => (this.recurrenceDays[0] = Number(value).toString())
        );
    }

    hasUrl(event) {
        if (event.checked) {
            this.hasURL = true;
            this.firstFormGroup.controls["longUrl"].setValidators([
                Validators.required,
            ]);
        } else {
            this.hasURL = false;
            this.firstFormGroup.controls["longUrl"].clearValidators();
            this.firstFormGroup.controls["longUrl"].updateValueAndValidity();
        }
    }

    onSelect(event: MatSelectChange) {
        let template = event.value as SMSTemplate;
        this.grupos = template.groups;
        this.firstFormGroup.controls["message"].setValue(template.content);
        this.firstFormGroup.controls["shortcode"].setValue(template.shortCode);
        this.firstFormGroup.controls["grupo"].setValue(template.groups);

        if (template.url_code !== null && template.url_code !== "") {
            this.hasURL = true;
            this.firstFormGroup.controls["longUrl"].setValue(template.url_code);
        }

        this.smsModel.template_id = template.id;
        this.smsModel.service_type = template.service_type;
        this.smsModel.shortCode = template.shortCode;
    }

    dateLessThan(from: string, to: string) {
        return (group: FormGroup): { [key: string]: any } => {
            const f = group.controls[from];
            const t = group.controls[to];

            if (t.value === null) {
                return {};
            }

            if (f.value > t.value) {
                return {
                    dates: "La fecha de inicio debe ser menor a la fecha fin",
                };
            }
            return {};
        };
    }

    compareFn(op1: any, op2: any) {
        if (op2 === null || op2 === undefined) {
            return;
        }
        return op1.id === op2.id;
    }

    ngOnInit() {
        this.loadTemplates();
    }

    performAction() {
        if (!this.esRecurrente) {
            this.smsModel.execute_end_date = moment(
                moment(this.smsModel.execute_date, "YYYY-MM-DD")
                    .add(1, "days")
                    .subtract(1, "seconds"),
                "YYYY-MM-DD HH:mm:ss"
            ).toString();
            // this.smsModel.recurrence_mode = '0000000';
        } else {
            this.smsModel.recurrence_mode = this.recurrenceDays.join("");
        }

        if (!this.isValidContactHour(this.smsModel.execute_time)) {
            const { hour_period_end, hour_period_init } = this.contactRule;
            const companyHourInit = hour_period_init.split(":")[0];
            const companyHourEnd = hour_period_end.split(":")[0];

            toastr.warning(
                this.translateService.instant(
                    `La hora de ejecucion de la campaña debe ser entre las ${companyHourInit} y las ${companyHourEnd}`
                ),
                "Sms"
            );
            return;
        }

        if (this.firstFormGroup.invalid || this.secondFormGroup.invalid) {
            return;
        }

        this.isWaiting = true;
        this.smsModel.recurrence_mode = this.recurrenceDays.join("");
        this.smsModel.obfuscated = this.hideMessage;

        this.callback(this.smsModel);
    }

    radioChange(event: any) {
        switch (event.value) {
            case "3":
                this.disabledDiasEspecificos = false;
                this.checkedRadioButon = 3;
                if (this.resetSelection === true) {
                    this.secondFormGroup.controls["lunes"].setValue(false);
                    this.secondFormGroup.controls["martes"].setValue(false);
                    this.secondFormGroup.controls["miercoles"].setValue(false);
                    this.secondFormGroup.controls["jueves"].setValue(false);
                    this.secondFormGroup.controls["viernes"].setValue(false);
                    this.secondFormGroup.controls["sabado"].setValue(false);
                    this.secondFormGroup.controls["domingo"].setValue(false);
                }
                break;
            default:
                this.disabledDiasEspecificos = true;
                this.smsModel.recurrence_mode = "1111111";
                this.recurrenceDays = this.smsModel.recurrence_mode.split("");
                this.checkedRadioButon = 1;
                break;
        }
    }

    isValidContactHour(value: string) {
        if (value) {
            console.log(value);

            const { hour_period_end, hour_period_init } = this.contactRule;
            const companyHourInit = hour_period_init.split(":")[0];
            const companyHourEnd = hour_period_end.split(":")[0];

            const workingHour = value.split(":");
            const HH = workingHour[0];
            const mm = workingHour[1];

            if (
                Number(HH) >= +companyHourInit &&
                Number(HH) <= +companyHourEnd
            ) {
                return true;
            }
        }

        return false;
    }
}
